import { render, staticRenderFns } from "./FeedbackEditor.vue?vue&type=template&id=62be78be&scoped=true&"
import script from "./FeedbackEditor.vue?vue&type=script&lang=ts&"
export * from "./FeedbackEditor.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackEditor.vue?vue&type=style&index=0&id=62be78be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62be78be",
  null
  
)

export default component.exports